import { Col, Form, Radio } from 'antd';
import type { IField } from '../data';

const { Item } = Form;

const RadioGroup: React.FC<IField> = (props) => {
    const { name, span = 8, label, options, onChange, xs, lg, marginBottom = 0, t, size } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };
    return (
        <Col key={name} {...grid}>
            <Item name={name} {...styling} label={t?.(label)}>
                <Radio.Group onChange={onChange} size={size}>
                    {options?.map((option) => (
                        <Radio value={option.key} key={option.key}>
                            {t?.(option.value)}
                        </Radio>
                    ))}
                </Radio.Group>
            </Item>
        </Col>
    );
};

export default RadioGroup;
